// https://vike.dev/Head#only-html
export function Head() {
    return null;
}
